import { Level } from './ScoresResponse';

export interface QuestionResponse {
    data: Question[];
    count: number;
}

export interface Question {
    module_id: string;
    level_id: Level;
    question_id: number;
    question_type: QuestionType;
    model_version: string;
    illustration_url: string | null;
    video_url: string | null;
    created_at: string;
    question_unique_id: string;
    question_content: string;
    answers: string[];
    good_answers: string[];
    good_answers_details: string[];
    is_green: boolean[];
}

export enum QuestionType {
    quizz = 'quizz',
    jeuFleche = 'jeu fléché',
    goNogo = 'go no-go',
    resistanceCognitive = 'resistance cognitive',
    puzzleDePhrase = 'puzzle de phrases',
    texteATrous = 'texte à trous',
    simulation = 'simulation ouverte',
}
